<template>
  <span v-bind="attrs"> {{ sTitulo }} </span>
</template>
<script>
export default {
  name: "Titulo",
  props: {
    sTitulo: String,
    attrs: {
      type: Object,
      default: () => {},
    },
  },
};
</script>